export const agreementTranslations = {
  lv: {
    title: 'Līgumi',
    count_zero: '{{count}} līgumu',
    count_one: '{{count}} līgums',
    count_other: '{{count}} līgumi',
    search: 'Meklēt pēc praktikanta, prakses vietas, līguma numura…',
    empty: 'Līgumi nav atrasti',
    statusTabs: 'Līgumu statuss',
    tabs: {
      all: 'Visi',
      toSignEdu: 'Gaida izglītības iestādes parakstu',
      toSignOther: 'Gaida citas puses',
      missingData: 'Trūkst datu',
      signed: 'Parakstīti',
    },
    statuses: {
      toSignEdu: 'Gaida izglītības iestādes parakstu',
      toSignIntern: 'Gaida praktikanta parakstu',
      toSignOrg: 'Gaida prakses vietas parakstu',
      missingData: 'Trūkst datu',
      missingOrg: 'Nav prakses vietas',
      signed: 'Parakstīts',
    },
    columns: {
      select: 'Atzīmēt',
      nr: 'Nr.',
      agreementId: 'Līguma ID',
      intern: 'Praktikants',
      org: 'Prakses vieta',
      eduSigned: 'Iestādes paraksts',
      orgSigned: 'Vietas paraksts',
      internSigned: 'Praktikanta paraksts',
      status: 'Statuss',
    },
    notAssigned: 'Nav piešķirta',
    signed: 'Parakstīts',
    signedBy: 'Parakstīts — {{signatory}}, {{date}}',
    notSigned: 'Nav parakstīts',
    selectAll: 'Atzīmēt visus redzamos',
    selectRow: 'Atzīmēt {{name}}',
    signSelected: 'Parakstīt atzīmētos ({{count}})',
    selectedNone: 'Atzīmējiet līgumus, ko gribat parakstīt',
    notYet: 'Šī darbība vēl nav pieejama: {{action}}',
    filters: {
      button: 'Filtri',
      title: 'Filtrēt līgumus',
      clear: 'Notīrīt',
      apply: 'Filtrēt',
      active: 'Aktīvie filtri',
      remove: 'Noņemt filtru “{{filter}}”',
      group: 'Grupa',
      internship: 'Prakse',
      template: 'Līguma sagatave',
      all: 'Visas',
      inactive: '{{text}} (neaktīva)',
    },
    actions: {
      menu: 'Līguma darbības',
      sign: 'Parakstīt',
      download: 'Lejupielādēt līgumu',
      edit: 'Labot līguma datus',
      uploadSigned: 'Augšupielādēt parakstītu līgumu',
      reset: 'Atiestatīt līgumu',
      create: 'Izveidot līgumu',
      changeSignatureParty: 'Mainīt paraksta pusi',
    },
    parties: {
      Edu: 'Izglītības iestāde',
      Intern: 'Praktikants',
      Org: 'Prakses vieta',
    },
    upload: {
      hint: 'Augšupielādējiet .edoc vai .asice failu. Tajā jābūt visiem līdz šim pievienotajiem parakstiem un vismaz vienam jaunam.',
      file: 'Parakstītais līgums',
      fileRequired: 'Izvēlieties parakstīto līguma failu',
      party: 'Jauno parakstu puse',
      submit: 'Augšupielādēt',
    },
    reset: {
      confirm:
        'Līgums {{nr}} tiks dzēsts kopā ar visiem parakstiem un parakstīto failu. Tā vietā tiks izveidots jauns līgums ar jaunu numuru, kura dati būs jāpārbauda.',
      submit: 'Atiestatīt',
    },
    create: {
      confirm:
        'Prakses vietai {{org}} tiks izveidots līgums ar nākamo numuru. Tā dati būs jāpārbauda.',
      submit: 'Izveidot',
    },
    changeParty: {
      hint: 'Norādiet, kurai pusei pieder katrs paraksts.',
      party: 'Puse — {{signatory}}',
      submit: 'Saglabāt',
    },
    editData: {
      sections: {
        org: 'Uzņēmums',
        signatory: 'Paraksttiesīgā persona',
        orgSupervisor: 'Uzņēmuma prakses vadītājs',
        eduSupervisor: 'Izglītības iestādes prakses vadītājs',
      },
      fields: {
        orgName: 'Nosaukums',
        orgRegNo: 'Reģistrācijas numurs',
        orgAddress: 'Juridiskā adrese',
        internshipPlace: 'Prakses vietas adrese',
        orgPhone: 'Tālrunis',
        orgEmail: 'E-pasts',
        orgFormal: 'Uzvārds, vārds',
        orgPK: 'Personas kods',
        orgReason: 'Pilnvarojums',
        orgSupervisor: 'Uzvārds, vārds',
        orgSupervisorPhone: 'Tālrunis',
        orgSupervisorEmail: 'E-pasts',
        eduSupervisor: 'Uzvārds, vārds',
        eduSupervisorPhone: 'Tālrunis',
        eduSupervisorEmail: 'E-pasts',
        additionalInfo: 'Papildu informācija',
      },
      required: 'Lauks nav aizpildīts',
      emailInvalid: 'Nepareizs e-pasts',
      save: 'Saglabāt',
      saved: 'Līguma dati saglabāti',
      loadFailed: 'Līguma datus neizdevās ielādēt',
      saveFailed: 'Līguma datus neizdevās saglabāt',
    },
    messages: {
      uploaded: 'Parakstītais līgums augšupielādēts',
      reset: 'Līgums atiestatīts',
      created: 'Līgums izveidots',
      partyChanged: 'Parakstu puses saglabātas',
      downloadError: 'Līgumu neizdevās lejupielādēt',
      failed: 'Darbība neizdevās',
    },
  },
  en: {
    title: 'Agreements',
    count_one: '{{count}} agreement',
    count_other: '{{count}} agreements',
    search: 'Search by intern, workplace, agreement number…',
    empty: 'No agreements found',
    statusTabs: 'Agreement status',
    tabs: {
      all: 'All',
      toSignEdu: 'Awaiting the institution’s signature',
      toSignOther: 'Awaiting other parties',
      missingData: 'Missing data',
      signed: 'Signed',
    },
    statuses: {
      toSignEdu: 'Awaiting the institution’s signature',
      toSignIntern: 'Awaiting the intern’s signature',
      toSignOrg: 'Awaiting the workplace’s signature',
      missingData: 'Missing data',
      missingOrg: 'No workplace',
      signed: 'Signed',
    },
    columns: {
      select: 'Select',
      nr: 'No.',
      agreementId: 'Agreement ID',
      intern: 'Intern',
      org: 'Workplace',
      eduSigned: 'Institution signature',
      orgSigned: 'Workplace signature',
      internSigned: 'Intern signature',
      status: 'Status',
    },
    notAssigned: 'Not assigned',
    signed: 'Signed',
    signedBy: 'Signed — {{signatory}}, {{date}}',
    notSigned: 'Not signed',
    selectAll: 'Select all visible',
    selectRow: 'Select {{name}}',
    signSelected: 'Sign selected ({{count}})',
    selectedNone: 'Select the agreements you want to sign',
    notYet: 'This action is not available yet: {{action}}',
    filters: {
      button: 'Filters',
      title: 'Filter agreements',
      clear: 'Clear',
      apply: 'Apply filters',
      active: 'Active filters',
      remove: 'Remove “{{filter}}” filter',
      group: 'Group',
      internship: 'Internship',
      template: 'Agreement template',
      all: 'All',
      inactive: '{{text}} (inactive)',
    },
    actions: {
      menu: 'Agreement actions',
      sign: 'Sign',
      download: 'Download agreement',
      edit: 'Edit agreement data',
      uploadSigned: 'Upload signed agreement',
      reset: 'Reset agreement',
      create: 'Create agreement',
      changeSignatureParty: 'Change signing party',
    },
    parties: {
      Edu: 'Institution',
      Intern: 'Intern',
      Org: 'Workplace',
    },
    upload: {
      hint: 'Upload an .edoc or .asice file. It must contain every signature added so far and at least one new one.',
      file: 'Signed agreement',
      fileRequired: 'Choose the signed agreement file',
      party: 'Party of the new signatures',
      submit: 'Upload',
    },
    reset: {
      confirm:
        'Agreement {{nr}} will be deleted together with all its signatures and the signed file. A new agreement with a new number will be created in its place, and its data will need to be checked.',
      submit: 'Reset',
    },
    create: {
      confirm:
        'An agreement with the next number will be created for the workplace {{org}}. Its data will need to be checked.',
      submit: 'Create',
    },
    changeParty: {
      hint: 'Choose which party each signature belongs to.',
      party: 'Party — {{signatory}}',
      submit: 'Save',
    },
    editData: {
      sections: {
        org: 'Company',
        signatory: 'Authorized signatory',
        orgSupervisor: 'Company supervisor',
        eduSupervisor: 'Institution supervisor',
      },
      fields: {
        orgName: 'Name',
        orgRegNo: 'Registration number',
        orgAddress: 'Legal address',
        internshipPlace: 'Internship location address',
        orgPhone: 'Phone',
        orgEmail: 'Email',
        orgFormal: 'Last name, first name',
        orgPK: 'Personal ID',
        orgReason: 'Authorization',
        orgSupervisor: 'Last name, first name',
        orgSupervisorPhone: 'Phone',
        orgSupervisorEmail: 'Email',
        eduSupervisor: 'Last name, first name',
        eduSupervisorPhone: 'Phone',
        eduSupervisorEmail: 'Email',
        additionalInfo: 'Additional information',
      },
      required: 'Field not filled',
      emailInvalid: 'Invalid email',
      save: 'Save',
      saved: 'Agreement data saved',
      loadFailed: 'The agreement data could not be loaded',
      saveFailed: 'The agreement data could not be saved',
    },
    messages: {
      uploaded: 'Signed agreement uploaded',
      reset: 'Agreement reset',
      created: 'Agreement created',
      partyChanged: 'Signature parties saved',
      downloadError: 'The agreement could not be downloaded',
      failed: 'The action failed',
    },
  },
}
